<template>
  <material-card>
    <v-layout slot="header" px-3>
      <v-flex mt-2 pl-3 align-center justify-center>
        <div class="headline">Karty klienta</div>

        <p>Karty przypisane do klienta</p>
      </v-flex>
    </v-layout>

    <v-layout row justify-center>
      <v-flex xs12>
        <v-layout row wrap class="px-1">
          <v-spacer />
        </v-layout>

        <div v-if="cards.length > 0">
          <v-card v-for="(card, index) in cards" :key="index" class="ma-2">
            <v-card-text style="position: relative">
              <v-layout row wrap>
                <v-flex xs8>
                  <v-layout row wrap>
                    <v-flex xs12 md6>
                      <p>
                        <b>Numer:</b>
                        {{ card.number ? card.number : 'Brak' }}
                      </p>

                      <p v-if="card.accepted">
                        <b>Data wydania:</b>
                        {{ card.accepted | moment('DD-MM-YYYY') }}
                      </p>

                      <v-chip v-if="card.duplicate" small class="ma-0"> <v-icon>info</v-icon> nowa karta </v-chip>

                      <v-chip small>
                        <v-icon>{{ card.physical ? 'mdi-card-text-outline' : 'mdi-at' }}</v-icon>

                        <span class="ml-1">
                          {{ card.physical ? 'Fizyczna' : 'Elektroniczna' }}
                        </span>
                      </v-chip>
                    </v-flex>

                    <v-flex xs12 md6>
                      <p>
                        <b class="mr-1">Status:</b>

                        <span v-if="isDateLaterThanNow(card.blockEndDate)">
                          Zablokowana do {{ card.blockEndDate | moment('DD-MM-YYYY') }}
                        </span>

                        <span v-else-if="card.endDate && !isDateLaterThanNow(card.endDate)">
                          Przedawniona
                        </span>

                        <span v-else>{{ card.state | state }}</span>
                      </p>

                      <p>
                        <b>Ważna od:</b>
                        {{ card.startDate | moment('DD-MM-YYYY') }}
                      </p>

                      <p v-if="card.endDate">
                        <b>Ważna do:</b>
                        {{ card.endDate | moment('DD-MM-YYYY') }}
                      </p>
                    </v-flex>

                    <v-flex>
                      <p v-if="card.blockReason">
                        <b>Powód blokady:</b>
                        {{ card.blockReason }}
                      </p>

                      <p v-if="card.inactiveReason">
                        <b>Powód unieważnienia:</b>
                        {{ card.inactiveReason }}
                      </p>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs4 class="text-xs-right">
                  <v-layout align-center justify-start row reverse fill-height>
                    <check-permission permissions="CARD.UPDATE">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn flat small icon color="primary" @click="editCard(card.id)" v-on="on">
                            <v-icon>mdi-pencil-outline</v-icon>
                          </v-btn>
                        </template>

                        <span> Edycja karty </span>
                      </v-tooltip>
                    </check-permission>

                    <check-permission v-if="CardState[card.state] === CardState.ACTIVE" permissions="CARD.ORDER_PRINT">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn flat small icon color="blue" @click="openOrderPrint(card.id)" v-on="on">
                            <v-icon>mdi-printer</v-icon>
                          </v-btn>
                        </template>

                        <span> Zleć wydruk karty </span>
                      </v-tooltip>
                    </check-permission>

                    <check-permission v-if="CardState[card.state] === CardState.READY" permissions="CARD.COLLECT">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn flat small icon color="blue" @click="openCollectCardModal(card.id)" v-on="on">
                            <v-icon>mdi-credit-card-refund</v-icon>
                          </v-btn>
                        </template>

                        <span> Wydaj kartę </span>
                      </v-tooltip>
                    </check-permission>

                    <check-permission
                      v-if="[CardState.ACTIVE, CardState.READY].includes(CardState[card.state]) && card.physical"
                      permissions="CARD.DUPLICATE"
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            flat
                            small
                            icon
                            color="primary"
                            @click="openConfirm(card, confirmEnum.DUPLICATE)"
                            v-on="on"
                          >
                            <v-icon>mdi-cards-outline</v-icon>
                          </v-btn>
                        </template>

                        <span>Wydawanie nowej karty</span>
                      </v-tooltip>
                    </check-permission>

                    <check-permission
                      v-if="![CardState.INACTIVE, CardState.NOT_CONFIRMED].includes(CardState[card.state])"
                      permissions="CARD.EXTEND_EXPIRATION"
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            flat
                            small
                            icon
                            color="primary"
                            @click="openConfirm(card, confirmEnum.EXTEND)"
                            v-on="on"
                          >
                            <v-icon>mdi-calendar</v-icon>
                          </v-btn>
                        </template>

                        <span>Przedłuż ważność karty o rok</span>
                      </v-tooltip>
                    </check-permission>

                    <check-permission
                      v-if="![CardState.INACTIVE, CardState.NOT_CONFIRMED].includes(CardState[card.state])"
                      permissions="CARD.REDUCE_EXPIRATION"
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn flat small icon color="error" @click="openConfirm(card, confirmEnum.REDUCE)" v-on="on">
                            <v-icon>mdi-calendar-minus</v-icon>
                          </v-btn>
                        </template>

                        <span>Skróć ważność karty o rok</span>
                      </v-tooltip>
                    </check-permission>

                    <check-permission
                      v-if="CardState.INACTIVE != CardState[card.state] && !isDateLaterThanNow(card.blockEndDate)"
                      :permissions="['CARD.DEACTIVATE', 'CARD.BLOCK']"
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn flat small icon color="error" @click="confirmBlock(card.id)" v-on="on">
                            <v-icon>mdi-cancel</v-icon>
                          </v-btn>
                        </template>

                        <span>Usunięcie karty</span>
                      </v-tooltip>
                    </check-permission>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </div>
      </v-flex>
    </v-layout>

    <card-modal :id="editId" :show="cardModal" :profile-id="id" @close="hideCardModal" />

    <card-block-modal :card-id="editId" :show="blockModal" @save="blockCard($event)" @close="hideCardBlockModal" />

    <card-collect-modal
      :card-id="editId"
      :show="modals.collectModal"
      @save="collectCard"
      @close="hideCollectCardModal"
    />

    <card-order-print :card-id="editId" :show="modals.orderPrint" @save="printCard" @close="closeOrderPrint" />

    <confirm-modal
      :description="confirmModal.description"
      :title="confirmModal.title"
      :show="modals.confirmCardUpdate"
      @close="closeConfirm"
      @confirm="confirmed"
    />
  </material-card>
</template>

<script>
import { CardState, CardStateTranslation, formatError } from '@witkac/kartamiejska-shared';
import { mapState } from 'vuex';

import ConfirmModal from '@/components/helpers/ConfirmModal';
import MaterialCard from '@/components/material/Card';
import { displayModalMixin } from '@/mixins/displayModal';
import { notificationsMixin } from '@/mixins/notifications';
import CardModal from '../modals/Card.modal';
import CardBlockModal from '../modals/CardBlock.modal';
import CardCollectModal from '../modals/CardCollect.modal';
import CardOrderPrint from '../modals/CardOrderPrint.modal.vue';

const emptyConfirm = {
  type: '',
  title: '',
  description: '',
  card: null
};
// @vuese
// Wyświetlanie zakładki kart klienta
// @group Client-Profile
export default {
  components: { CardModal, CardBlockModal, CardCollectModal, CardOrderPrint, ConfirmModal, MaterialCard },
  filters: {
    state(value) {
      return CardStateTranslation[CardState[value]];
    }
  },
  mixins: [displayModalMixin, notificationsMixin],
  data() {
    return {
      cardModal: false,
      blockModal: false,
      confirmDialog: false,
      editId: undefined,
      CardState,
      confirmModal: {
        ...emptyConfirm
      },
      confirm: {
        DUPLICATE: {
          title: 'Czy na pewno chcesz stworzyć nową kartę?',
          description: 'Utworzenie nowej karty spowoduje, że dotychczasowa karta zostanie natychmiastowo unieważniona.'
        },
        EXTEND: {
          title: 'Czy na pewno chcesz przedłużyć ważność karty o rok?',
          description: 'Zatwierdzenie spowoduje przedłużenie daty ważności karty o rok.'
        },
        REDUCE: {
          title: 'Czy na pewno chcesz skrócić ważność karty o rok?',
          description: 'Zatwierdzenie spowoduje skrócenie ważności karty o rok.'
        }
      },
      confirmEnum: {
        DUPLICATE: 'DUPLICATE',
        EXTEND: 'EXTEND',
        REDUCE: 'REDUCE'
      }
    };
  },

  computed: mapState({
    cards: state => state.client.cards.list,
    id: state => state.client.data.profile.id
  }),
  watch: {
    modalClose(val) {
      if (val) {
        this.hideCardModal();
        this.hideCardBlockModal();
      }
    },
    '$store.state.modalClose.confirm'(val) {
      if (val) {
        this.$store.dispatch('resetConfirmState');
      } else {
        this.hideCardModal();
        this.hideCardBlockModal();
      }
    }
  },
  mounted() {
    this.getCards();
  },
  methods: {
    // @vuese
    // funkcja wywołuje pobranie listy kart klienta do store
    getCards() {
      this.$store.dispatch('client/cards/list');
    },
    // @vuese
    // funkcja ukrywa modal edycji / dodawania karty
    hideCardModal() {
      this.cardModal = false;
      this.editId = undefined;
    },
    // @vuese
    // funkcja ustawia dane do potwierdzenia
    confirmBlock(id) {
      this.editId = id;
      this.showBlockModal();
    },
    // @vuese
    // funkcja ukrywa modal potwierdzenia usunięcia karty
    hideCardBlockModal() {
      this.editId = undefined;
      this.$set(this, 'blockModal', false);
    },
    // @vuese
    // funkcja wywołuje modal potwierdzenia usunięcia karty
    showBlockModal() {
      this.blockModal = true;
    },
    // @vuese
    // blokowanie karty
    blockCard(model) {
      if (model.deactivate) {
        this.removeCard(model.cardId);
        return;
      }
      this.blockCardPeriod(model);
    },
    // @vuese
    // blokowanie karty na określony czas
    blockCardPeriod(model) {
      this.$store
        .dispatch('client/cards/timeBlock', { id: model.cardId, blockEndDate: model.blockEndDate })
        .then(() => {
          this.notifySuccess('Zablokowano kartę');
          this.hideCardBlockModal();
        })
        .catch(() => this.notifyError('Nie udało się zablokować karty'));
    },
    // @vuese
    // funkcja wywołuje usunięcie karty klienta poprzez store
    // @arg `id` - ID karty do usunięcia
    removeCard(id) {
      this.$store
        .dispatch('client/cards/block', id)
        .then(() => {
          this.notifySuccess('Zablokowano kartę');
          this.hideCardBlockModal();
        })
        .catch(() => this.notifyError('Nie udało się zablokować karty'));
    },
    // @vuese
    // funkcja wywołuje modal edycji karty
    // @arg `id` - ID karty do edycji
    editCard(id) {
      this.editId = id;
      this.cardModal = true;
    },

    // @vuese
    // funkcja sprawdza czy podana data jest późniejsza niż teraz
    // @arg `laterDate` - Data do sprawdzenia czy
    isDateLaterThanNow(laterDate) {
      const now = new Date().valueOf();
      return new Date(laterDate) >= now;
    },

    // @vuese
    // Potwierdzenie modala
    confirmed() {
      switch (this.confirmModal.type) {
        case this.confirmEnum.DUPLICATE:
          this.duplicateCard();
          break;
        case this.confirmEnum.EXTEND:
          this.extendCard();
          break;
        case this.confirmEnum.REDUCE:
          this.reduceCard();
          break;
      }
    },

    // @vuese
    // Przedłużanie ważności karty
    extendCard() {
      this.$store
        .dispatch('client/cards/extendExpirationDateByYear', this.confirmModal.card.id)
        .then(this.closeConfirm);
    },

    // @vuese
    // Skrócenie ważności karty
    reduceCard() {
      this.$store
        .dispatch('client/cards/reduceExpirationDateByYear', this.confirmModal.card.id)
        .then(this.closeConfirm)
        .catch(err => this.notifyError(formatError(err)));
    },

    // @vuese
    // Wydanie duplikatu karty
    duplicateCard() {
      this.$store.dispatch('client/cards/duplicateCard', this.confirmModal.card.number).then(this.closeConfirm);
    },
    // @vuese
    // Zlecenie druku karty
    printCard(data) {
      this.$store.dispatch('client/cards/printCard', data).then(this.closeOrderPrint);
    },
    // @vuese
    // Zamknięcie modala
    closeConfirm() {
      this.confirmModal = {
        ...emptyConfirm
      };
      this.closeModal('confirmCardUpdate');
    },
    // @vuese
    // Otworzenie potwierdzenia chęci wydania duplikatu
    openConfirm(card, type) {
      this.confirmModal.card = card;
      this.confirmModal.type = type;
      this.confirmModal.title = this.confirm[type].title;
      this.confirmModal.description = this.confirm[type].description;
      this.openModal('confirmCardUpdate');
    },
    // @vuese
    // Zamknięcie modala zamówienia karty
    closeOrderPrint() {
      this.editId = undefined;
      this.closeModal('orderPrint');
    },
    // @vuese
    // Otworzenie modala zamówienia karty
    openOrderPrint(cardId) {
      this.editId = cardId;
      this.openModal('orderPrint');
    },
    // @vuese
    // Otworzenie potwierdzenia wydania kart
    openCollectCardModal(cardId) {
      this.editId = cardId;
      this.openModal('collectModal');
    },
    collectCard(data) {
      this.$store.dispatch('client/cards/collectCard', data).then(() => {
        this.hideCollectCardModal();
      });
    },
    // @vuese
    // Zamknięcie potwierdzenia wydania kart
    hideCollectCardModal() {
      this.editId = undefined;
      this.closeModal('collectModal');
    }
  }
};
</script>
